import React, { useEffect, useState } from "react";
import PcApp from "../pc/App";
import MobileApp from "../mobile/App";
import { detectDevice } from "./detectDevice";
import "./selection.less";
import "../../../common/button.less";

/** 设备判定：先用 detectDevice 区分 pad / phone / pc；pad 与 pc 都走 PcApp（pad 由 pc/App 内部分横竖屏） */
const MOBILE_MQ = "(max-width: 767px)";
const PREVIEW_CLOSE_MESSAGE = "official-news-preview-close";

/** 后台预览通过 iframe 打开：查询参数仅标识模式和资讯 id，展示内容取详情接口。 */
const previewParams =
  typeof window !== "undefined"
    ? new URLSearchParams(window.location.search)
    : new URLSearchParams();
const previewMode = previewParams.get("previewMode") === "1";
const previewNewsId = previewParams.get("previewNewsId") || null;

function handlePreviewClose() {
  if (!previewMode || window.parent === window) return;
  window.parent.postMessage(
    { type: PREVIEW_CLOSE_MESSAGE },
    window.location.origin
  );
}

function detectMobile() {
  const platform = detectDevice();
  if (platform === "phone") return true;
  if (platform === "pad" || platform === "pc") return false;
  /* 兜底：视口 ≤720 视为 mobile */
  if (typeof window.matchMedia === "function") {
    return window.matchMedia(MOBILE_MQ).matches;
  }
  return false;
}

/**
 * 顶层包一层，监听 matchMedia 变更：DevTools 切设备 / 拖窗宽时实时切换 PC ↔
 * Mobile。UA 命中真机时锁死 mobile，不再随窗宽变。
 *
 * 同时作为 official_website_new.js 与 official_website/App.jsx 两个入口的统
 * 一调度点，避免新增设备分发逻辑时漏改另一处。
 */
export default function DeviceRouter() {
  const [isMobile, setIsMobile] = useState(detectMobile);

  useEffect(() => {
    /* 真机 UA 命中 phone 时锁死 mobile，不再随窗宽变；其它情况随 viewport 变化重算 */
    const onChange = () => setIsMobile(detectMobile());
    if (typeof window.matchMedia !== "function") return undefined;
    const mq = window.matchMedia(MOBILE_MQ);
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    }
    /* Safari < 14 / 老 webview */
    mq.addListener(onChange);
    return () => mq.removeListener(onChange);
  }, []);

  /* 预览模式 Esc 关闭：焦点在 iframe 文档内时，后台页面的 keydown 收不到，
     必须由 iframe 自己监听后 postMessage 回去（关闭按钮走同一条消息） */
  useEffect(() => {
    if (!previewMode) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") handlePreviewClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  /* 后台预览只在 PC 端使用，移动端不做预览适配，保持原有落地页 */
  return isMobile ? (
    <MobileApp />
  ) : (
    <PcApp
      previewMode={previewMode}
      previewNewsId={previewNewsId}
      onPreviewClose={handlePreviewClose}
    />
  );
}
